// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16Kvg","footer":"styles_footer____NPW"};